<template>
  <div class="send-report">
    <!-- 返回 -->
    <div class="back-btn">
      <router-link
        :to="{ name: 'EmailList' }"
        class="routelink"
      >
        返回
      </router-link>
      / 发送报告
    </div>
    <!-- 搜索 -->
    <div class="search-box">
      <a-dropdown>
        <a
          class="ant-dropdown-link"
        >
          {{ selectName }}
          <i class="iconfont iconicon-test15" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item
            v-for="option in taskNameList"
            :key="option.id"
            @click="handleChange(option.id)"
          >
            <a>
              {{ option.name }}
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <!-- 数据汇总 -->
    <ul
      v-if="statisticsData"
      class="data-nums clearfix"
    >
      <li>
        <p>打开</p>
        <p>{{ statisticsData.openpeople }}</p>
      </li>
      <li>
        <p>点击</p>
        <p>{{ statisticsData.clickpeople }}</p>
      </li>
      <li>
        <p>弹出</p>
        <p>{{ statisticsData.failnum }}</p>
      </li>
      <li>
        <p>退订</p>
        <p>{{ statisticsData.unsubscribenum }}</p>
      </li>
    </ul>
    <ul
      v-if="statisticsData"
      class="data-details clearfix"
    >
      <li>
        <span class="name">成功送达</span>
        <span
          v-if="statisticsData.delivered"
          class="text"
        >{{ statisticsData.delivered.split(/\s+/ig)[0] }} <span class="fs-gray666">{{ statisticsData.delivered.split(/\s+/ig)[1] }}</span></span>
      </li>
      <li>
        <span class="name">点击次数</span>
        <span class="text">{{ statisticsData.clicknum }}</span>
      </li>
      <li>
        <span class="name">打开次数</span>
        <span class="text">{{ statisticsData.opennum }}</span>
      </li>
      <li>
        <span class="name">最后点击</span>
        <span class="text">{{ statisticsData.lastclicktime }}</span>
      </li>
      <li>
        <span class="name">最后打开</span>
        <span class="text">{{ statisticsData.lastopentime }}</span>
      </li>
      <!-- <li>
        <span class="name">转发</span>
        <span class="text">{{ statisticsData.unsubscribenum }}</span>
      </li> -->
    </ul>
    <a-tabs
      :active-key="eventname"
      tab-position="top"
      :animated="false"
      @change="tabCallback"
    >
      <a-tab-pane
        key="opened"
        tab="打开"
      />
      <a-tab-pane
        key="clicked"
        tab="点击"
      />
      <a-tab-pane
        key="fail"
        tab="弹回"
      />
      <a-tab-pane
        key="unsubscribed"
        tab="退订"
      />
      <a-tab-pane
        key="delivered"
        tab="投递成功"
      />
    </a-tabs>
    <!-- 表格数据 -->
    <ul
      v-if="!loading"
      class="report-list"
    >
      <li
        v-for="item in listDatas"
        :key="item.id"
        class="item clearfix"
      >
        <a
          v-if="eventname === 'clicked'"
          :href="item.url"
          target="_blank"
          class="fs-blue"
        >{{ item.url }}</a>
        <span
          v-else
          class="email"
        >{{ item.recipient }}</span>
        <span class="fr">{{ item.eventnum }}</span>
      </li>
    </ul>
    <div
      v-if="!listDatas || !listDatas.length"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />暂无数据
    </div>
    <pagination
      v-if="listDatas && listDatas.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Pagination from '@/components/pc/Pagination'

export default {
  name: 'SendReport',
  components: {
    Pagination
  },
  data () {
    return {
      eventname: this.$route.query.eventname || 'opened',
      selectid: this.$route.query.emailid ? Number(this.$route.query.emailid) : undefined
    }
  },

  computed: {
    ...mapState('edm/sendReport', ['loading', 'statisticsData', 'listDatas', 'pagination', 'taskNameList']),
    emailid () {
      return this.$route.query.emailid || ''
    },

    selectName () {
      let curr = this.taskNameList.find(item => item.id === this.selectid)
      return curr && curr.name
    },

    protocol () {
      return location.protocol
    },

    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    }
  },

  watch: {
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize
      this.getList()
      if (to.query.emailid !== from.query.emailid) {
        this.fetchStatistics({
          taskid: this.emailid
        })
      }
    }
  },

  async created () {
    this.pagination.currentPage = this.currentPage
    this.pagination.pageSize = this.pageSize

    this.fetchTaskNameList()
    this.getData()
  },

  methods: {
    ...mapActions('edm/sendReport', ['fetchTaskNameList', 'fetchStatistics', 'fetchEmailEventList']),
    tabCallback (key) {
      this.eventname = key
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          eventname: this.eventname
        }
      })
    },
    handleChange (val) {
      this.selectid = val
      // this.getData()
      this.$router.push({
        query: {
          ...this.$route.query,
          emailid: val,
          page: 1,
          limit: 10
        }
      })
    },
    async getData () {
      await this.fetchStatistics({
        taskid: this.emailid
      })
      await this.getList({
        taskid: this.emailid,
        eventname: this.eventname
      })
    },
    async getList (params = {}) {
      params.page = this.pagination.currentPage
      params.limit = this.pagination.pageSize
      params.taskid = this.emailid || ''
      params.eventname = this.eventname
      await this.fetchEmailEventList(params)
    },
    handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-box {
  margin: 24px 0;
  .ant-dropdown-link {
    // width: 320px;
    font-size: 18px;
    .iconfont {
      font-size: 12px;
      color: #D8D8D8;
    }
  }
}
.data-nums {
  // margin-bottom: 24px;
  li {
    float: left;
    width:248px;
    height:122px;
    margin-right: 15px;
    margin-bottom: 24px;
    padding: 24px;
    text-align: center;
    background:#F5F8FB;
    border-radius:8px;
    &:last-child {
      margin-right: 0;
    }
    p:nth-child(1) {
      color:#666;
      font-size: 14px;
    }
    p:nth-child(2) {
      margin-top: 10px;
      font-size: 40px;
    }
  }
}
.data-details {
  overflow: hidden;
  margin-bottom: 24px;
  li {
    position: relative;
    float: left;
    width: 50%;
    height: 40px;
    line-height: 40px;
    // padding: 8px 0;
    .name {
      display: inline-block;
      width: 60px;
      margin-right: 290px;
      text-align: right;
    }
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 65px;
      width: 280px;
      border-bottom: solid 1px #EBEBEB;
    }
  }
}
.report-list {
  margin-top: 24px;
  .item {
    padding: 12px 0;
    border-bottom: solid 1px #EBEBEB;
    .email {
      color: #666;
    }
    .fs-blue {
        color: #5077aa;
      }
    .fr {
      margin-right: 16px;
    }
  }
}
.empty-box {
  padding: 50px 0 100px;
  text-align: center;
  color: #666;
  .logo {
    display: block;
    margin: 8px auto;
    font-size: 24px;
    color: #d6d6d6;
  }
  .placeholder {
    margin-bottom: 16px;
    color: $gray3;
  }
}
</style>
